import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      padding-block-start: 0.5ex;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n\n  color: var(", ");\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: none;\n  fill-rule: evenodd;\n  stroke: currentColor;\n  stroke-width: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-block-start: -0.5ex;\n  margin-inline-end: var(", ");\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { injectTypography } from '../../utils/injectTypography';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';

var getTextColor = function getTextColor(props) {
  switch (props.variant) {
    case 'invalid':
      return props.theme.colors.ui.error;

    default:
      return props.theme.colors.ui.tertiary;
  }
};

export var StyledErrorIcon = styled.svg(_templateObject(), function (props) {
  return props.theme.responsive.spacing.xs;
});
export var StyledErrorIconPath = styled.path(_templateObject2());
export var StyledFormHelperText = styled.div(_templateObject3(), function (props) {
  return props.variant === 'invalid' && css(_templateObject4());
}, function (props) {
  return getTextColor(props);
}, function (props) {
  return injectTypography(props, 'copy2');
}, injectOSXFontSmoothing(true), injectSpacing('margin'));